import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Tab, Tabs } from 'react-bootstrap';
import Loader from '../../components/Loader';
import {
  csaUserGroup,
  exhibitUserGroup,
  superUserGroup,
  UrlPath,
} from '../../constants';
import { addContract } from '../../redux/actions';
import smartHttp from '../../helpers/smartHttp';
import CommonDropdown from '../../sharedcomponents/CommonDropdown/CommonDropdown';
import {
  Endpoints,
  userPreferencesKey,
  ContractDisplayOptions,
  PersistReduxAction,
  viewerUserGroup,
  Cancelled,
} from './../../constants';
import DeleteEntitlements from './DeleteEntitlements';
import AddEntitlements from './AddEntitlements';
import ExportEntitlements from './ExportEntitlements';
import ProductEntitlements from './ProductEntitlements';
import Entitlements from './Entitlements';
import EntitlementsServerside from './Entitlements-serverside';
import SalesforceEntitlementsServerside from './SalesforceEntitlements-serverside';
import store from './../../redux/store';
import { useSelector } from 'react-redux';
import persistDataStore from './../../redux/persistStore';
import {
  getCSAContractsData,
  updateVirtualContractsData,
} from './../../helpers/component-helper-methods';

const EntitlementsContainer = () => {
  const [loading, setLoading] = useState(true);
  const [dropDownLoader, setDropDownLoader] = useState(true);
  const [breadCrumbValue, setBreadCrumbValue] = useState();
  const [isBPMReferral, setIsBPMReferral] = useState(null); // null initially
  const [contractsResult, setContractsResult] = useState([]);
  const [isViewerUser, setIsViewerUser] = useState(false);
  const [contractDisplayOption, setContractDisplayOption] = useState();
  const [showContractDropdown, setShowContractDropdown] = useState(true);
  const subscriptionManagerTabName = 'subscription-manager';
  const salesforceTabName = 'salesforce';
  const [activeEntitlementTab, setActiveEntitlementTab] = useState(
    subscriptionManagerTabName,
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const getContractsDataSet = async (userEmail) => {
    try {
      let csaActionData =
        persistDataStore.getState()?.userActionData?.csaUserActionInfo;
      userEmail = userEmail.toLowerCase();

      let queryParamsContract = {
        PageSize: 5000,
        Field:
          'contractNumber,HomogenizedCompany,contractType,contractDescription,bulkEntitlementEnable,isVirtualContract,mappedcontractnumber,contractStatus,hC_AccountID',
        Filter: `email:"${userEmail}"`,
      };

      // Filter out cancelled contracts for non-super users
      const userGroups = store.getState()?.userInfo?.userInfo?.SPGGroups || [];
      const isSuperUser = userGroups.includes(superUserGroup);
      if (!isSuperUser) {
        if (queryParamsContract.Filter) queryParamsContract.Filter += ' and ';
        queryParamsContract.Filter += `contractStatus!:"${Cancelled}"`;
      }

      let storeData = store.getState();
      let storeContracts = storeData?.contract;
      if (
        storeContracts &&
        storeContracts.contracts &&
        storeContracts.contracts.length > 0
      ) {
        setContractsResult(storeContracts.contracts);
      } else {
        if (csaActionData?.type && csaActionData?.value) {
          let csaContracts = await getCSAContractsData();
          setDropDownLoader(false);
          // Dispatch contracts to Redux first - this filters out suspended contracts for CCA/End Users
          dispatch(addContract(csaContracts));
          // Now read back the filtered contracts from Redux store to keep local state in sync
          const filteredContracts = store.getState()?.contract?.contracts || [];
          setContractsResult(filteredContracts);
        } else {
          const contractResponse = await smartHttp.get(
            Endpoints.contractApi,
            queryParamsContract,
          );
          let tempState = contractResponse.data?.results?.map((el, i) => {
            return {
              label:
                el.contractNumber +
                (el.contractDescription ? ' - ' + el.contractDescription : ''),
              id: el.contractNumber,
              checked: true,
              bulkEntitlementEnable: el.bulkEntitlementEnable,
              homogenizedCompany: el.homogenizedCompany,
              ...el,
            };
          });
          // Filter for distinct contractNumbers
          const distinctContracts = tempState.reduce((acc, current) => {
            const existingContract = acc.find(
              (item) => item.contractNumber === current.contractNumber,
            );
            if (!existingContract) {
              acc.push(current);
            }
            return acc;
          }, []);
          tempState = updateVirtualContractsData(distinctContracts);
          setContractsResult(tempState);
          tempState = updateVirtualContractsData(tempState);
          // Dispatch contracts to Redux first - this filters out suspended contracts for CCA/End Users
          dispatch(addContract(tempState));
          // Now read back the filtered contracts from Redux store to keep local state in sync
          const filteredContracts = store.getState()?.contract?.contracts || [];
          setContractsResult(filteredContracts);
        }
      }
    } catch (err) {
    } finally {
      setDropDownLoader(false);
      setLoading(false);
      // FEATURE DISABLED (Release july-2026) - Exhibit persona check
      // const isExhibitUser = storeUserInfo?.SPGGroups?.includes(exhibitUserGroup);
      // if (!isExhibitUser) {
      if (true) {
        // FEATURE DISABLED - always run non-exhibit path
        let storeData = store.getState();
        let storeContracts = storeData.contract;
        setShowContractDropdown(!storeContracts?.isVirtualContract);
      }
    }
  };

  useEffect(() => {
    const init = async () => {
      let storeData = store.getState();
      let storeUserInfo = storeData.userInfo;
      if (storeUserInfo && storeUserInfo.userInfo) {
        setIsViewerUser(
          storeUserInfo.userInfo.SPGGroups?.includes(viewerUserGroup) &&
            !storeUserInfo.userInfo.SPGGroups?.includes(csaUserGroup) &&
            !storeUserInfo.userInfo.SPGGroups?.includes(superUserGroup),
        );
        // FEATURE DISABLED (Release july-2026) - Exhibit persona / BPM Referral
        // const isExhibitUser = storeUserInfo.userInfo.SPGGroups?.includes(exhibitUserGroup);
        // setIsBPMReferral(!!isExhibitUser);
        // if (isExhibitUser) {
        //   setShowContractDropdown(false);
        //   const userContracts = storeData?.userContracts?.userContracts;
        //   const exhibitContractNumber = userContracts?.[0]?.contractNumber;
        //   if (exhibitContractNumber) {
        //     const ccaData = { type: 'contract', data: null, value: exhibitContractNumber };
        //     persistDataStore.dispatch({ type: PersistReduxAction.csaActionData, payload: ccaData });
        //   }
        // }
        setIsBPMReferral(false); // FEATURE DISABLED (Release july-2026)
        const isExhibitUser = false; // FEATURE DISABLED (Release july-2026)
        await getContractDisplayOption(storeUserInfo.userInfo.userPreferences);
        getContractsDataSet(storeUserInfo.userInfo.email);
      }
    };
    init();
  }, [useSelector((x) => x.userInfo)]);

  // set header breadcrumb to CSA selected value
  useEffect(() => {
    let csaActionData =
      persistDataStore.getState()?.userActionData?.csaUserActionInfo;
    let breadCrumbData =
      csaActionData?.type === 'account'
        ? csaActionData?.data?.account
        : csaActionData?.type === 'hccompany'
          ? csaActionData?.data?.homogenizedCompany
          : csaActionData?.value;
    setBreadCrumbValue(isBPMReferral ? '' : breadCrumbData);
  }, [isBPMReferral]);

  const selectedCount = contractsResult.reduce(
    (counter, obj) => (obj.checked === true ? (counter += 1) : counter),
    0,
  );

  const handleTabSelect = (tabName) => {
    if (
      // tabName === 'entitlements' &&
      window.location.pathname !== UrlPath.entitlements
    ) {
      navigate(UrlPath.entitlements);
    }
  };
  const onContractChangeHandler = (contracts) => {
    setContractsResult(contracts);
    dispatch(addContract(contracts));
  };

  const getContractDisplayOption = async (userPreferences) => {
    try {
      if (
        userPreferences?.find(
          (x) => x.preferenceKey === userPreferencesKey['displayContract'],
        )
      ) {
        setContractDisplayOption(
          userPreferences.find(
            (x) => x.preferenceKey === userPreferencesKey['displayContract'],
          ),
        );
      } else {
        setContractDisplayOption({
          preferenceValue: ContractDisplayOptions[0].contractDisplayOption,
        });
      }
    } catch (err) {}
  };

  const getContractLabelKey = () => {
    if (contractDisplayOption) {
      if (
        contractDisplayOption.preferenceValue ===
        ContractDisplayOptions[1].contractDisplayOption
      ) {
        return 'contractDescription';
      }
      if (
        contractDisplayOption.preferenceValue ===
        ContractDisplayOptions[2].contractDisplayOption
      ) {
        return 'label';
      }
    }

    return 'contractNumber';
  };

  return (
    <>
      {loading ? (
        <Loader type="scaleLoader" />
      ) : (
        <>
          <div className="row">
            <div className="col-lg-8 col-md-5">
              <span id="entitlements-header" className="page-header">
                <span className=" breadcrumb-nav-wrapper">
                  <span className="cursor-pointer" onClick={handleTabSelect}>
                    {window.location.pathname === UrlPath.deleteEntitlements
                      ? 'Delete Entitlements'
                      : 'Manage Entitlements'}{' '}
                  </span>
                  {window.location.pathname === UrlPath.entitlements ? (
                    <span className="breadcrumb-nav" title={breadCrumbValue}>
                      {breadCrumbValue ? ` / ${breadCrumbValue}` : ''}
                    </span>
                  ) : window.location.pathname === UrlPath.addEntitlements ? (
                    <>
                      <span className="breadcrumb-nav"> / New Entitlement</span>
                      <span className="breadcrumb-nav" title={breadCrumbValue}>
                        {breadCrumbValue ? ` / ${breadCrumbValue}` : ''}
                      </span>
                    </>
                  ) : window.location.pathname ===
                    UrlPath.exportEntitlements ? (
                    <>
                      <span className="breadcrumb-nav">/ Export</span>
                      <span className="breadcrumb-nav" title={breadCrumbValue}>
                        {breadCrumbValue ? ` / ${breadCrumbValue}` : ''}
                      </span>
                    </>
                  ) : window.location.pathname ===
                    UrlPath.productEntitlements ? (
                    <>
                      <span
                        className="breadcrumb-nav"
                        title="Manage Product / Email Preferences"
                      >
                        / Manage Product / Email Preferences
                      </span>
                      <span className="breadcrumb-nav" title={breadCrumbValue}>
                        {breadCrumbValue ? ` / ${breadCrumbValue}` : ''}
                      </span>
                    </>
                  ) : (
                    ''
                  )}
                </span>
              </span>
            </div>
            <div
              className={`col-lg-4 col-md-7${
                showContractDropdown ? '' : ' d-none'
              }`}
            >
              <CommonDropdown
                mode="multi"
                enableSearch={true}
                enableSelectAll={true}
                defaultSelectAll={true}
                labelKeyName={getContractLabelKey()}
                ddOptionsKey="id"
                options={contractsResult}
                setOptions={onContractChangeHandler}
                ddName="contracts"
                ddPlaceHolder={
                  selectedCount === 0
                    ? 'Contracts: (0)'
                    : selectedCount === contractsResult.length
                      ? 'Contracts: All Contracts'
                      : `Contracts:`
                }
              />
            </div>
          </div>
          {/* Tab section */}
          <div>
            {window.location.pathname === UrlPath.entitlements ? (
              <div className="tabs-main entitlements-tabs-main">
                <Tabs
                  fill
                  justify
                  defaultActiveKey={subscriptionManagerTabName}
                  activeKey={activeEntitlementTab}
                  onSelect={(key) => setActiveEntitlementTab(key)}
                  mountOnEnter
                >
                  <Tab
                    eventKey={subscriptionManagerTabName}
                    title="Subscription Manager"
                  >
                    <EntitlementsServerside
                      contracts={contractsResult}
                      isViewerUser={isViewerUser}
                      isBPMReferral={isBPMReferral}
                    />
                  </Tab>
                  <Tab eventKey={salesforceTabName} title="Salesforce">
                    <SalesforceEntitlementsServerside
                      contracts={contractsResult}
                    />
                  </Tab>
                </Tabs>
              </div>
            ) : window.location.pathname === UrlPath.addEntitlements ? (
              <>
                <div className="tabs-main">
                  <AddEntitlements
                    isBPMReferral={isBPMReferral}
                    contracts={contractsResult}
                  />
                </div>
                <div
                  title="Currently subscribed by other users"
                  className="mt-1"
                >
                  🟢 Currently subscribed by other users
                </div>
              </>
            ) : window.location.pathname === UrlPath.deleteEntitlements ? (
              <>
                <div className="tabs-main">
                  <DeleteEntitlements contracts={contractsResult} />
                </div>
              </>
            ) : window.location.pathname === UrlPath.exportEntitlements ? (
              <div className="tabs-main">
                <ExportEntitlements contracts={contractsResult} />
              </div>
            ) : (
              <div className="tabs-main">
                <ProductEntitlements
                  isBPMReferral={isBPMReferral}
                  contracts={contractsResult}
                />
              </div>
            )}
            {/* <Tabs
              fill
              justify
              defaultActiveKey="entitlements"
              onSelect={handleTabSelect}
            >
              <Tab eventKey="entitlements" title="All Entitlements">
                {window.location.pathname === UrlPath.entitlements ? (
                  <Entitlements contracts={contractsResult}></Entitlements>
                ) : (
                  <AddEntitlements contracts={contractsResult} />
                )}
              </Tab>
              <Tab eventKey="bundles" title="Entitlements Bundles">
                <Container className="entitlemets-bundles-content">
                  <h4>You don't have any bundles</h4>
                  <p>
                    Create entitlement bundles to easily assign multiple users,
                    or user groups, the same set of entitlements.
                  </p>
                  <p>
                    Select Users, Packages or Delivery Platform to start the
                    entitlement bundles creation process.
                  </p>
                </Container>
              </Tab>
            </Tabs> */}
          </div>
        </>
      )}
    </>
  );
};

const mapDispatchToProps = {
  addContract,
};

export default connect(null, mapDispatchToProps)(EntitlementsContainer);
